import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable } from 'rxjs';
import { IOpenedPrintOptionsAccordions } from '../interfaces/opened-print-options-accordions.interface';
import * as fromActions from './app.state.actions';
import * as fromReducer from './app.state.reducer';
const debug = Debug('aumico:admin:AppStateDispatcher');

@Injectable({
    providedIn: 'root',
})
export class AppStateDispatcher {
    constructor(private store: Store<fromReducer.AppState>) {}

    setUploadedFileChanged(fileChanged: boolean) {
        this.store.dispatch(fromActions.onSetUploadedFileChanged({ payload: fileChanged }));
    }

    getUploadedFileChanged(): Observable<boolean> {
        return this.store.select(fromReducer.selectuploadedFileChanged);
    }

    setSupportOperation(supportOperation: boolean) {
        this.store.dispatch(fromActions.onSetSupportOperation({ payload: supportOperation }));
    }

    getSupportOperation(): Observable<boolean> {
        return this.store.select(fromReducer.selectSupportOperation);
    }

    setOpenedPrintOptionsAccordions(openedAccordions: IOpenedPrintOptionsAccordions) {
        this.store.dispatch(fromActions.onSetOpenedPrintOptionsAccordions({ payload: openedAccordions }));
    }

    getOpenedPrintOptionsAccordions(): Observable<IOpenedPrintOptionsAccordions> {
        return this.store.select(fromReducer.selectOpenedPrintOptionsAccordions);
    }
}
